import React from "react";
import { Switch, Route } from "react-router-dom";
import TillViews from "views/till-views";
import Loading from "components/shared-components/Loading";
import { useThemeSwitcher } from "react-css-theme-switcher";

export const TillLayout = () => {
  const { status } = useThemeSwitcher();

  if (status === "loading") {
    return <Loading cover="page" />;
  }

  return (
    <div>
      <Switch>
        <Route path="" component={TillViews} />
      </Switch>
    </div>
  );
};

export default TillLayout;
